import { render } from "./Handbook.vue?vue&type=template&id=c841daae"
import script from "./Handbook.vue?vue&type=script&lang=js"
export * from "./Handbook.vue?vue&type=script&lang=js"

import "./Handbook.vue?vue&type=style&index=0&id=c841daae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__